import {
    setLoading,
    setIntegrations,
    setEnabledIntegrations,
} from "../reducers/integrations";
import axios from "axios";
import { setErrorMessage } from "./common";
import { AppThunk } from "../redux/store";
import { EnabledIntegration, IntegrationsItem } from "../typeDefs/integrations";
import {
    parseSqlDateTime,
    parseSqlDateTimeNullable,
} from "../components/common/utils/utils";

export const getIntegrations = (): AppThunk<void> => (dispatch) => {
    dispatch(setLoading(true));
    axios
        .get<any[]>("api/integrations/all")
        .then((res) => {
            const data = res.data.map(
                (i): IntegrationsItem => ({
                    Id: i.Id,
                    Name: i.Name,
                    ImageUrl: i.ImageUrl,
                    Description: i.Description,
                    Tags: i.Tags
                        ? i.Tags.split(",").map((tag: string): string =>
                              tag.trim()
                          )
                        : [],
                    ClientSettingId: i.ClientSettingId,
                    SponsoredSortOrder: i.SponsoredSortOrder,
                    Type: i.Type,
                    LinkUrl: i.LinkUrl,
                    Grouping: i.Grouping,
                })
            );
            dispatch(setIntegrations(data));
            dispatch(setLoading(false));
        })
        .catch((err) => {
            console.error(err);
            dispatch(setErrorMessage("Failed to get integrations"));
            dispatch(setLoading(false));
        });
};

export const getEnabledIntegrations = (): AppThunk<void> => (dispatch) => {
    dispatch(setLoading(true));
    axios
        .get<any[]>("api/integrations/enabled")
        .then((res) => {
            const data = res.data.map(
                (i): EnabledIntegration => ({
                    Id: i.Id,
                    DateRequested: parseSqlDateTime(i.DateRequested),
                    DateEnabled: parseSqlDateTimeNullable(i.DateEnabled),
                    DateDeleted: parseSqlDateTimeNullable(i.DateDeleted),
                })
            );
            dispatch(setEnabledIntegrations(data));
            dispatch(setLoading(false));
        })
        .catch((err) => {
            console.error(err);
            dispatch(setErrorMessage("Failed to get enabled integrations"));
            dispatch(setLoading(false));
        });
};

export const enableIntegration =
    (id: string): AppThunk<Promise<void>> =>
    async (dispatch) => {
        try {
            await axios.patch(`api/integrations?integrationsId=${id}`);
            dispatch(getEnabledIntegrations());
        } catch (err) {
            console.error(err);
        }
    };

export const disableIntegration =
    (id: string): AppThunk<Promise<void>> =>
    async (dispatch) => {
        try {
            await axios.delete(`api/integrations?integrationsId=${id}`);
            dispatch(getEnabledIntegrations());
        } catch (err) {
            console.error(err);
        }
    };

export const requestNewIntegration = async (newIntegration: string) => {
    try {
        await axios.patch(
            `api/integrations/request?newIntegration=${newIntegration}`
        );
        return true;
    } catch (err) {
        console.error(err);
        return false;
    }
};
